export const CarouselVariant = {
  SMALL: 'SMALL',
  SMALL_FRAME: 'SMALL_FRAME',
  MEDIUM: 'MEDIUM'
}
